<ng-container *ngIf="isLoading() ; else content">


    <div class="flex items-center justify-center min-h-[300px]">
        <p-progress-spinner ariaLabel="loading My favorites" />
    </div>
</ng-container>

<ng-template #content>
    <div class=" bg-gray-20 lg:border-b border-gray-300">
        <div class=" container mx-auto lg:mb-10 ">

            <div class="flex flex-col lg:flex-row mx-auto">
                <div class="w-full">
                    <p class="text-xl text-[var(--charcoal)] mt-4"> Items show up in Favorites when you bid, buy, or add
                        them, and stay for 90 days after closing.
                        <br>
                        Removing them doesn’t cancel your bids. Follow <a class="font-bold"
                            href="https://support.frontstream.com/hc/en-us/articles/115005896266-Bidders-How-to-Request-a-Bid-Retraction">these
                            steps </a>if you need to retract a bid.
                    </p>
                </div>
            </div>

        </div>

        <div class="w-full mt-8">
            <div class="flex justify-end mb-4 lg:mb-8">
                <p-select [options]="sortFilters" [(ngModel)]="selectedSortSignal" placeholder="Sort by" class="">
                </p-select>
            </div>

            <app-favorites-page [items]=" items().length > 10 ? paginatedItems() : sortedItems()"
                (removedFavorite)="onRemoveFavorite($event)"></app-favorites-page>

        </div>

        @if(items().length > 10)
        {
        <p-paginator [rows]="rows()" [first]="first()" [totalRecords]="sortedItems().length"
            [rowsPerPageOptions]="rowsPerPageOptions" (onPageChange)="onPageChange($event)" styleClass="mt-7 text-sm">
        </p-paginator>

        }

    </div>
</ng-template>